import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  standalone: true,
    selector: 'app-actions-cell-renderer',
    template: `
    <button mat-icon-button color="primary" (click)="onView()">
      <mat-icon>visibility</mat-icon>
    </button>
  `,
    imports: [
        MatIconModule,
        MatButtonModule
    ]
})
export class ActionsCellRendererComponent implements ICellRendererAngularComp {
  params: any;

  agInit(params: any): void {
    this.params = params;
  }

  refresh(): boolean {
    return false;
  }

  onView() {
    if (this.params?.context?.componentParent?.viewPayload) {
      this.params.context.componentParent.viewPayload(this.params.data);
    }
  }
}
